import { environment } from '../environments/environment';

/**
 * @module Unlockd Config
 * @description
 *
 * The Unlockdconfig module help to externally
 * configure the base url and api version for Unlockdconfig
 *
 **/

export class Unlockdconfig {

  public static getPath(): string {
    return environment.path;
  }

  public static getAppPath(): string {
    return environment.appPath1;
  }

  public static getCmsPath(): string {
    return environment.cms_path;
  }
  public static getStaticPath(): string {
    return environment.staticPath;
  }
  public static getBuyerModuleStatus(): boolean {
    return environment.buyerModule;
  }
    public static getDownloadOfferPath(): string {
    return environment.offer_download_lambda_path;
  }
  public static getEnvironment(): string {
    if(window.location.origin.includes('localhost') || window.location.origin.includes('dev')){
      return 'dev';
    }else if(window.location.origin.includes('stage')){
      return 'stage';
    } else {
      return 'live';
    }
  }

  // public static getEnvPath(): string {
  //   return '';
  //   // return environment.apiBase + '/' + Qpconfig.api_version;
  // }
}
